import React, { useEffect, useState } from "react";
import ArtistTile from "../../components/ArtistTile";
import { endpoints } from "../../utils/Constants";
import { eventGroupId } from "../../utils/Utils";

const ArtistsWidget = () => {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    let culture = $("#lng").val();
    let countryCode = 'gr'
    let language = culture.split('-')[0];

    fetch(endpoints.event.getEventGroupArtists(eventGroupId(), culture), {
      method: "GET",
    })
      .then((res) => res.json())
      .then((result) => {
          result.forEach(artist => {
              artist.documentUrl = '/'.concat(countryCode, '-',language,artist.documentUrl)
          });
        setArtists(result);
      })
      .catch((error) => {
        console.error(`Can't fetch artist!`, error);
      });
  };

  let tiles = artists.map((artist, index) => (
    <ArtistTile key={index} data={artist} />
  ));

  return artists?.length > 0 ? (
    <div
      id="r_artistsSection"
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "0 16px",
        gap: 24,
      }}
    >
      <span
        style={{
          color: "#0D0C1C",
          fontSize: 20,
          fontFamily: "pf_highway_sans_pro_mediumRg",
        }}
      >
        {artistpage_resources.Artists}
      </span>
      <div
        style={{
          display: "flex",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        {tiles}
      </div>
    </div>
  ) : null;
};

export default ArtistsWidget;
